module.exports = __webpack_public_path__ + "img/waist.bc28945c.png";